import Styled,{css } from 'styled-components'

export const Container = Styled.div`
 display: flex;
 flex-direction:  ${props => props.orientation || 'column'};
 justify-content: ${props => props.justifyContent || 'center'};
 min-height:74px; 
 align-items: center;
 p {
  margin: 0;
 }
`

export const Tachado = Styled.p`
 text-decoration: line-through;
 font-size: 13px;
`

export const Bold = Styled.b`
font-size: 14px;
color : var(--text-dark);
`

export const Box = Styled.div`
  span {
    display:flex;
    gap: 5px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    word-wrap: break-word;
    color: ${props => props.theme.whitelabel?.text_primary_color};
  }
  .tachado-price {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    word-wrap: break-word
    color: ${props => props.theme.whitelabel?.text_primary_color};
  }
  .por-price {
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    word-wrap: break-word
  }
`